import { filesStore } from './input-file-upload'

const feedbackFormAction = () => {
  const form = document.getElementById('electron-reception-form')
  const submitButton = document.querySelector('[data-feedback-submit]')
  const modalSuccess = document.querySelector('[data-modal-feedback-success]')
  const modalError = document.querySelector('[data-modal-feedback-error]')
  const regexpEmail = /^[A-Z0-9._%+-]+@[A-Z0-9-]+.+.[A-Z]{2,4}$/i
  const regexpPhone = /(?:\+|\d)[\d\-\(\) ]{9,}\d/g

  if (form) form.setAttribute('novalidate', 'novalidate')

  const isErrorMessage = (field, isError, errText, tooltipText) => {
    const el = document.querySelector(`[data-input-${field}]`)
    const button = document.querySelector(`[data-${field}-clear]`)
    const err = document.querySelector(`[data-error-${field}]`)
    const tooltip = document.querySelector(`[data-tooltip-${field}]`)

    if (isError) {
      el.classList.add('is-error')
      button && button.style.setProperty('--input-field-icon-color', '#ee3f58')
      err.innerText = errText
      tooltip.innerText = tooltipText

      submitButton.disabled = true
    } else {
      el.classList.remove('is-error')
      button && button.style.setProperty('--input-field-icon-color', '#9dacce')
      err.innerText = ''
      tooltip.innerText = ''
    }
  }

  form &&
    form.addEventListener('input', () => {
      const formData = new FormData(form)

      const data = Object.fromEntries(formData)

      if (
        data.message &&
        data.lastName &&
        data.firstName &&
        data.email &&
        Object.hasOwn(data, 'checkbox1') &&
        Object.hasOwn(data, 'checkbox2')
      ) {
        if (submitButton.disabled) {
          submitButton.disabled = false
        }
      } else {
        if (submitButton.disabled == false) {
          submitButton.disabled = true
        }
      }
    })

  form &&
    form.addEventListener('submit', async (event) => {
      event.preventDefault()

      const formData = new FormData(form)
      const data = Object.fromEntries(formData)

      filesStore.forEach((file) => {
        formData.append('files[]', file)
      })

      if (data.message == false) {
        isErrorMessage(
          'message',
          true,
            foivL10n.specifyTextMessage,
            foivL10n.fieldCantBeEmpty,
        )
      } else {
        isErrorMessage('message')
      }

      if (data.lastName == false) {
        isErrorMessage(
          'lastName',
          true,
            foivL10n.specifyLastName,
            foivL10n.fieldCantBeEmpty,
        )
        return
      } else {
        isErrorMessage('lastName')
      }

      if (data.firstName == false) {
        isErrorMessage(
          'firstName',
          true,
            foivL10n.specifyFirstName,
            foivL10n.fieldCantBeEmpty,
        )
        return
      } else {
        isErrorMessage('firstName')
      }

      if (!data.email.match(regexpEmail)) {
        isErrorMessage(
          'email',
          true,
            foivL10n.specifyCorrectEmail,
          'adress@email.ru',
        )
        return
      } else {
        isErrorMessage('email')
      }

      if (data.phone !== '' && !data.phone.match(regexpPhone)) {
        isErrorMessage(
          'phone',
          true,
            foivL10n.specifyCorrectPhone,
          '7-000-00-00',
        )
        return
      } else {
        isErrorMessage('phone')
      }

      if (!data.checkbox1) {
        const checkbox = document.querySelector('[data-checkbox1]')
        checkbox.style.setProperty('--box-shadow-color', '#ee3f58')

        return
      }

      if (!data.checkbox2) {
        const checkbox = document.querySelector('[data-checkbox2]')
        checkbox.style.setProperty('--box-shadow-color', '#ee3f58')

        return
      }

      try {
        const response = await fetch('/api/v1/feedback/appeal', {
          method: 'POST',
          body: formData,
        })

        if (response.ok) {
          const checkbox1 = document.querySelector('[data-checkbox1]')
          const checkbox2 = document.querySelector('[data-checkbox2]')
          const file = document.querySelector('[data-files-container]')

          modalSuccess.classList.remove('is-invisible')
          modalSuccess.classList.add('is-layout-locked')
          form.reset()
          file.innerHTML = ''
          filesStore.splice(0, filesStore.length)

          checkbox1.style.setProperty('--box-shadow-color', '#0d4cd3')
          checkbox2.style.setProperty('--box-shadow-color', '#0d4cd3')
          submitButton.disabled = true
        } else {
          modalError.classList.remove('is-invisible')
          modalError.classList.add('is-layout-locked')

          response.json().then((data) => {
            if (Array.isArray(data))
              data.forEach((item) => {
                const err = item.split(' - ')
                switch (err[0]) {
                  case 'message':
                    isErrorMessage(err[0], true, err[1])
                    submitButton.disabled = true
                    break
                  case 'lastName':
                    isErrorMessage(err[0], true, err[1])
                    submitButton.disabled = true
                    break
                  case 'firstName':
                    isErrorMessage(err[0], true, err[1])
                    submitButton.disabled = true
                    break
                  case 'email':
                    isErrorMessage(err[0], true, err[1])
                    submitButton.disabled = true
                    break
                  case 'phone':
                    isErrorMessage(err[0], true, err[1])
                    submitButton.disabled = true
                    break
                  default:
                }
              })
          })
        }
      } catch {
        modalError.classList.remove('is-invisible')
        modalError.classList.add('is-layout-locked')
      }
    })
}

feedbackFormAction()
